// extracted by mini-css-extract-plugin
export default {"container":"Rectangle_container__7Mshg","header":"Rectangle_header__ocNS6","content":"Rectangle_content__1kmm1","btn":"Rectangle_btn__TUQoq"};